import React from 'react';
import { motion } from 'framer-motion';
import { Slide, itemVariants } from '../Slide';
import { WaydevLogo } from '../WaydevLogo';
export function SlideCover() {
  return <Slide className="justify-center items-center text-center" data-id="element-94">
      <motion.div variants={itemVariants} className="mb-12" data-id="element-95">
        <WaydevLogo className="h-32 md:h-48 lg:h-56 mx-auto" data-id="element-96" />
      </motion.div>

      <motion.h1 variants={itemVariants} className="text-4xl md:text-6xl lg:text-8xl font-serif tracking-tight max-w-5xl mx-auto leading-[1.1] mb-8" data-id="element-97">
        The internal brain of the modern engineering org.
      </motion.h1>

      <motion.div variants={itemVariants} className="absolute bottom-12 left-12 right-12 flex justify-between items-end text-sm text-gray-400 uppercase tracking-widest" data-id="element-98">
        <div data-id="element-99">Seed Round · 2026</div>
        <div className="text-right" data-id="element-100">
          Alex Circei
          <br data-id="element-101" />
          CEO & Co-founder
        </div>
      </motion.div>
    </Slide>;
}